module.exports = __webpack_public_path__ + "img/el-m-out50.98fb4c16.png";